<div class="relative z-10">
  @if (authService.user$ | async; as user) {
    <button
      (click)="toggleDropdown()"
      class="flex items-center justify-center rounded-full transition-opacity hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
      [attr.aria-expanded]="isOpen()"
      aria-haspopup="true"
    >
      @if (user.picture) {
        <img
          [src]="user.picture"
          [alt]="user.name ?? 'Usuario'"
          class="size-9 rounded-[8px] object-cover border border-gray-200 dark:border-gray-700"
        />
      } @else {
        <div class="flex size-9 items-center justify-center rounded-[8px] bg-primary text-[12px] font-medium text-[var(--brand-foreground,black)] tracking-wide">
          {{ getUserInitials(user) }}
        </div>
      }
    </button>

    @if (isOpen()) {
      <div class="fixed inset-0 z-1010" (click)="isOpen.set(false)"></div>
      <div
        class="absolute right-0 z-1030 mt-2 w-64 origin-top-right rounded-lg border shadow-xl animate-in fade-in slide-in-from-top-2 border-gray-200 bg-white dark:border-gray-800 dark:bg-black"
      >
        <div class="border-b border-gray-100 p-4 dark:border-gray-800">
          <p class="truncate text-sm font-semibold text-gray-900 dark:text-white">
            {{ user.name ?? 'Usuario' }}
          </p>
          <p class="mt-0.5 truncate text-xs text-gray-500 dark:text-gray-400">
            {{ user.email ?? '' }}
          </p>
        </div>

        <div class="p-1">
          <button
            [disabled]="isChangingPassword()"
            (click)="handleChangePassword(user.email)"
            class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-800"
            [ngClass]="{ 'cursor-wait opacity-50': isChangingPassword() }"
          >
            <lucide-icon [img]="KeyRound" class="h-4 w-4" [ngClass]="{ 'animate-spin': isChangingPassword() }"></lucide-icon>
            {{ isChangingPassword() ? 'Enviando...' : 'Cambiar contraseña' }}
          </button>

          <button
            (click)="handleLogout()"
            class="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-red-600 transition-colors hover:bg-red-50 dark:hover:bg-red-900/10"
          >
            <lucide-icon [img]="LogOut" class="h-4 w-4"></lucide-icon>
            Cerrar sesión
          </button>
        </div>
      </div>
    }
  } @else {
    <!-- Fallback if not authenticated yet -->
    <div class="flex size-9 items-center justify-center rounded-[8px] bg-primary text-[12px] font-medium text-[var(--brand-foreground,black)] tracking-wide">
      U
    </div>
  }
</div>
